import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { SparkleDecoration } from './ui/SparkleDecoration';
import { Star, Shield, Heart, Sparkles } from 'lucide-react';
export function ProMethodSection() {
  return <section className="pt-20 pb-24 relative overflow-hidden bg-gradient-to-b from-[#FBE6DF] to-cream" data-id="element-301">
      {/* Decorative Elements */}
      <div className="absolute top-10 left-5 opacity-40" data-id="element-302">
        <SparkleDecoration size={35} color="#E8735A" data-id="element-303" />
      </div>
      <div className="absolute top-40 right-10 opacity-30" data-id="element-304">
        <SparkleDecoration size={50} color="#6B1F2A" type="star" data-id="element-305" />
      </div>
      <div className="absolute bottom-20 left-1/4 opacity-40" data-id="element-306">
        <SparkleDecoration size={40} color="#F2A59D" type="star" data-id="element-307" />
      </div>
      <div className="absolute bottom-10 right-1/4 opacity-30" data-id="element-308">
        <SparkleDecoration size={25} color="#E8735A" data-id="element-309" />
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-310">
        <div className="text-center mb-16" data-id="element-311">
          <AnimatedSection data-id="element-312">
            <div className="inline-block bg-burgundy/10 text-burgundy font-bold px-4 py-1.5 rounded-full mb-4 text-sm tracking-wide uppercase" data-id="element-313">
              Exclusivo Método PRO
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-burgundy mb-6 leading-tight" data-id="element-314">
              Mega Pack PRO Mamá Imparable: <br className="hidden md:block" data-id="element-315" />
              <span className="text-coral" data-id="element-316">La Transformación Completa</span>
            </h2>
          </AnimatedSection>

          <AnimatedSection delay={0.1} data-id="element-317">
            <p className="text-lg md:text-xl text-charcoal/80 max-w-3xl mx-auto font-medium" data-id="element-318">
              Además de todo lo que incluye el Mega Pack, el Método PRO suma
              estos 4 tomos de intensificación para llevar tu organización al
              siguiente nivel.
            </p>
          </AnimatedSection>
        </div>

        <div className="grid grid-cols-2 gap-3 md:gap-4 max-w-3xl mx-auto mb-16" data-id="element-319">
          {/* Tomo 1 */}
          <AnimatedSection delay={0.2} data-id="element-320">
            <div className="bg-white rounded-xl p-4 md:p-5 shadow-soft border-l-4 border-coral h-full flex flex-col relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-321">
              <div className="absolute top-0 right-0 w-16 h-16 bg-coral/5 rounded-bl-full -z-10 transition-transform group-hover:scale-110" data-id="element-322" />
              <div className="flex items-start gap-3 mb-2" data-id="element-323">
                <div className="w-9 h-9 rounded-full bg-coral/10 flex items-center justify-center flex-shrink-0" data-id="element-324">
                  <Star className="w-4 h-4 text-coral" data-id="element-325" />
                </div>
                <div data-id="element-326">
                  <span className="text-coral font-bold text-[10px] tracking-wider uppercase mb-0.5 block" data-id="element-327">
                    Tomo 1
                  </span>
                  <h3 className="text-sm md:text-base font-serif font-bold text-burgundy leading-snug" data-id="element-328">
                    Sostener la Constancia en el Tiempo
                  </h3>
                </div>
              </div>
              <p className="text-charcoal/70 leading-relaxed flex-1 text-xs md:text-sm" data-id="element-329">
                Dominá el arte de mantener el orden y la organización a pesar de
                las dificultades del día a día.
              </p>
            </div>
          </AnimatedSection>

          {/* Tomo 2 */}
          <AnimatedSection delay={0.3} data-id="element-330">
            <div className="bg-white rounded-xl p-4 md:p-5 shadow-soft border-l-4 border-burgundy h-full flex flex-col relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-331">
              <div className="absolute top-0 right-0 w-16 h-16 bg-burgundy/5 rounded-bl-full -z-10 transition-transform group-hover:scale-110" data-id="element-332" />
              <div className="flex items-start gap-3 mb-2" data-id="element-333">
                <div className="w-9 h-9 rounded-full bg-burgundy/10 flex items-center justify-center flex-shrink-0" data-id="element-334">
                  <Shield className="w-4 h-4 text-burgundy" data-id="element-335" />
                </div>
                <div data-id="element-336">
                  <span className="text-burgundy font-bold text-[10px] tracking-wider uppercase mb-0.5 block" data-id="element-337">
                    Tomo 2
                  </span>
                  <h3 className="text-sm md:text-base font-serif font-bold text-burgundy leading-snug" data-id="element-338">
                    Navegar Imprevistos y Crisis
                  </h3>
                </div>
              </div>
              <p className="text-charcoal/70 leading-relaxed flex-1 text-xs md:text-sm" data-id="element-339">
                Estrategias prácticas para manejar imprevistos familiares sin
                perder la calma, desde accidentes escolares hasta cambios de
                rutina.
              </p>
            </div>
          </AnimatedSection>

          {/* Tomo 3 */}
          <AnimatedSection delay={0.4} data-id="element-340">
            <div className="bg-white rounded-xl p-4 md:p-5 shadow-soft border-l-4 border-rose h-full flex flex-col relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-341">
              <div className="absolute top-0 right-0 w-16 h-16 bg-rose/10 rounded-bl-full -z-10 transition-transform group-hover:scale-110" data-id="element-342" />
              <div className="flex items-start gap-3 mb-2" data-id="element-343">
                <div className="w-9 h-9 rounded-full bg-rose/20 flex items-center justify-center flex-shrink-0" data-id="element-344">
                  <Heart className="w-4 h-4 text-coral" data-id="element-345" />
                </div>
                <div data-id="element-346">
                  <span className="text-coral font-bold text-[10px] tracking-wider uppercase mb-0.5 block" data-id="element-347">
                    Tomo 3
                  </span>
                  <h3 className="text-sm md:text-base font-serif font-bold text-burgundy leading-snug" data-id="element-348">
                    Arquitectura Emocional
                  </h3>
                </div>
              </div>
              <p className="text-charcoal/70 leading-relaxed flex-1 text-xs md:text-sm" data-id="element-349">
                Aprendé a construir un entorno emocionalmente sano en casa,
                fortaleciendo la resiliencia familiar.
              </p>
            </div>
          </AnimatedSection>

          {/* Tomo 4 */}
          <AnimatedSection delay={0.5} data-id="element-350">
            <div className="bg-white rounded-xl p-4 md:p-5 shadow-soft border-l-4 border-coral h-full flex flex-col relative overflow-hidden group hover:-translate-y-1 transition-transform duration-300" data-id="element-351">
              <div className="absolute top-0 right-0 w-16 h-16 bg-coral/5 rounded-bl-full -z-10 transition-transform group-hover:scale-110" data-id="element-352" />
              <div className="flex items-start gap-3 mb-2" data-id="element-353">
                <div className="w-9 h-9 rounded-full bg-coral/10 flex items-center justify-center flex-shrink-0" data-id="element-354">
                  <Sparkles className="w-4 h-4 text-coral" data-id="element-355" />
                </div>
                <div data-id="element-356">
                  <span className="text-coral font-bold text-[10px] tracking-wider uppercase mb-0.5 block" data-id="element-357">
                    Tomo 4
                  </span>
                  <h3 className="text-sm md:text-base font-serif font-bold text-burgundy leading-snug" data-id="element-358">
                    Priorizar el Autocuidado sin Culpa
                  </h3>
                </div>
              </div>
              <p className="text-charcoal/70 leading-relaxed flex-1 text-xs md:text-sm" data-id="element-359">
                Técnicas para incorporar el autocuidado en tu rutina, sin
                sentirte egoísta ni descuidar a tu familia.
              </p>
            </div>
          </AnimatedSection>
        </div>

        <AnimatedSection delay={0.6} className="text-center" data-id="element-360">
          <p className="text-lg md:text-xl font-serif font-bold text-burgundy mb-6" data-id="element-361">
            Sumá el Método PRO y llevá tu organización familiar al siguiente
            nivel.
          </p>
          <a href="#precio" className="inline-block bg-emerald-500 text-white px-8 py-4 rounded-full font-bold text-lg hover:scale-105 transition-transform duration-300 shadow-xl" data-id="element-362">
            SÍ, QUIERO EL MEGA PACK PRO
          </a>
        </AnimatedSection>
      </div>
    </section>;
}